namespace GeniuzPOS.ReportMasterData {
    export interface Report_1408Form {
    }

    export class Report_1408Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1408';
    }
}
